// Articles
import wegZumSKSContent from './articles/weg-zum-sks.md';
import navigationGrundlagenContent from './articles/navigation-grundlagen.md';
import schifffahrtsrechtGrundlagenContent from './articles/schifffahrtsrecht-grundlagen.md';
import wetterkundeGrundlagenContent from './articles/wetterkunde-grundlagen.md';
import seemannschaftGrundlagenContent from './articles/seemannschaft-grundlagen.md';
import erfolgreichLernenContent from './articles/erfolgreich-lernen.md';
import kartenaufgabenContent from './articles/kartenaufgaben.md';
// Images
import wegZumSKSImage from '../../assets/wiki/WegZumSKSArticle/Bild1.jpeg';
import navigationImage from '../../assets/wiki/navigation_wiki.jpeg';
import schifffahrtsrechtImage from '../../assets/wiki/schifffahrtsrecht_wiki.jpeg';
import wetterkundeImage from '../../assets/wiki/wetterkunde_wiki.jpeg';
import seemannschaftImage from '../../assets/wiki/seemannschaft_wiki.jpeg';
import kartenaufgabenImage from '../../assets/wiki/kartenaufgabe.png';
import learn from '../../assets/wiki/learn.jpeg';
  
// Article metadata
const articles = [
  {
    slug: 'weg-zum-sks',
    title: 'Der Weg zum SKS-Schein',
    description: 'Ein umfassender Leitfaden für die SKS-Prüfung - Von den Voraussetzungen über die praktische Ausbildung bis zur theoretischen Prüfung.',
    image: wegZumSKSImage,
    content: wegZumSKSContent
  },
  {
    slug: 'kartenaufgaben',
    title: 'Kartenaufgaben im SKS-Schein',
    description: 'Ein umfassender Leitfaden für die SKS-Prüfung - Von den Voraussetzungen über die praktische Ausbildung bis zur theoretischen Prüfung.',
    image: kartenaufgabenImage,
    content: kartenaufgabenContent
  },
  {
    slug: 'erfolgreich-lernen',
    title: 'Erfolgreich lernen mit der MeinSKS-App',
    description: 'Umfassende Anleitung, wie Dir die MeinSKS-App hilft die theoretischen SKS-Fragen zu lernen.',
    image: learn,
    content: erfolgreichLernenContent
  },
  {
    slug: 'navigation',
    title: 'Navigation',
    description: 'Einführung in die Navigation einschließlich traditioneller und moderner Navigationsmethoden und deren praktische Anwendung in Küstengewässern.',
    image: navigationImage,
    content: navigationGrundlagenContent
  }, 
  {
    slug: 'schifffahrtsrecht',
    title: 'Schifffahrtsrecht',
    description: 'Übersicht über die wichtigsten Regeln und Vorschriften im Schifffahrtsrecht von den rechtlichen Grundlagen bis zur praktischen Anwendung.',
    image: schifffahrtsrechtImage,
    content: schifffahrtsrechtGrundlagenContent
  },
  {
    slug: 'wetterkunde',
    title: 'Wetterkunde',
    description: 'Grundlegendes Wissen über Wetterphänomene, Wettersysteme und deren praktische Bedeutung für die Navigation und Sicherheit auf See.',
    image: wetterkundeImage,
    content: wetterkundeGrundlagenContent
  },
  {
    slug: 'seemannschaft',
    title: 'Seemannschaft',
    description: 'Einführung in die seemännischen Fertigkeiten für Motor- und Segelyachten, von grundlegender Bootskunde bis zum Notfallmanagement.',
    image: seemannschaftImage,
    content: seemannschaftGrundlagenContent
  }
];

export default articles;